export default __webpack_public_path__ + "static/media/roboto-latin-300italic.bd5b7a13.woff";